// extracted by mini-css-extract-plugin
export default {"container":"Login_container__ISdlU","footer":"Login_footer__0CYFJ","footerItem":"Login_footerItem__I07mQ"};